import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';
import { BaseFilterComponent } from '../filter/base-filter.component';

@Component({
  selector: 'vectronic-input-search-filter',
  templateUrl: './input-search-filter.component.html',
  styleUrls: ['./input-search-filter.component.scss'],
  imports: [FilterHeaderComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
})
export class InputSearchFilterComponent extends BaseFilterComponent {}
